import * as React from "react";

import AppModals from "@app/AppModals";
import { FullScreenLoader } from "@v2/components/FullScreenLoader";
import { ProjectWebsocketProvider } from "@v2/features/multiplayer/ProjectWebsocketProvider";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";
import { Outlet } from "react-router-dom";

export default function ChatLayout() {
  const projectId = useCurrentProjectId();

  if (!projectId) {
    return <FullScreenLoader />;
  }

  return (
    <ProjectWebsocketProvider projectId={projectId}>
      <div className="flex flex-col w-full h-full min-h-0">
        <AppModals />
        <Outlet />
      </div>
    </ProjectWebsocketProvider>
  );
}
